import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// Simple cached fetch for the homepage config so multiple sections share it.
let cache = null;
let inflight = null;
const subscribers = new Set();

const notify = (data) => subscribers.forEach((cb) => cb(data));

const fetchConfig = async () => {
  if (cache) return cache;
  if (inflight) return inflight;
  inflight = axios.get(`${API}/api/homepage-config`).then((r) => {
    cache = r.data || {};
    inflight = null;
    notify(cache);
    return cache;
  }).catch(() => {
    inflight = null;
    return {};
  });
  return inflight;
};

export const invalidateHomepageConfig = () => {
  cache = null;
};

export const useHomepageConfig = () => {
  const [data, setData] = useState(cache);
  useEffect(() => {
    let cancelled = false;
    const cb = (d) => { if (!cancelled) setData(d); };
    subscribers.add(cb);
    if (!cache) fetchConfig();
    else setData(cache);
    return () => { cancelled = true; subscribers.delete(cb); };
  }, []);
  return data;
};
